import React from "react";
import { Form, InputGroup, Button, Card, Badge } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FaSearch, FaExternalLinkAlt } from "react-icons/fa";
import { Icon } from "../../../../../components/common/Icon";

interface SearchPreviewProps {
  searchQ: string;
  setSearchQ: (q: string) => void;
  searchResults: any[];
  handleSearchPreview: () => void;
}

const SearchPreview: React.FC<SearchPreviewProps> = ({
  searchQ,
  setSearchQ,
  searchResults,
  handleSearchPreview,
}) => {
  const { t } = useTranslation();

  return (
    <div className="search-preview-container">
      <InputGroup className="mb-3">
        <Form.Control
          placeholder="Type a question to test retrieval..."
          value={searchQ}
          onChange={(e) => setSearchQ(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              handleSearchPreview();
            }
          }}
        />
        <Button variant="primary" onClick={handleSearchPreview}>
          <Icon icon={FaSearch} className="me-2" />
          Search
        </Button>
      </InputGroup>

      <div className="search-results">
        {searchResults.length > 0 ? (
          searchResults.map((res, idx) => (
            <Card key={idx} className="mb-2 search-result-card">
              <Card.Body className="p-3">
                <div className="d-flex justify-content-between mb-2">
                  <Badge bg="info">Score: {res.score?.toFixed(3)}</Badge>
                  <small className="text-muted">
                    {res.source_title ? `Source: ${res.source_title}` : `Chunk ID: ${res.chunk_id}`}
                  </small>
                </div>
                <p className="mb-0 text-wrap text-break result-text">
                  {res.snippet || res.text || 'No content available'}
                </p>
              </Card.Body>
            </Card>
          ))
        ) : (
          <div className="text-center text-muted py-5">
            <Icon icon={FaSearch} size={24} className="mb-2 opacity-50" />
            <p>No results found or no search performed yet.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchPreview;



